export function FreeShippingCampaignTag(): React.ReactNode {
  return (
    <div className="mg__bottom__xs">
      <span className="tag bg__red inline-block square mini text__white mx-[5px] align-middle">
        今だけ初回送料無料
      </span>
    </div>
  );
}
